/* eslint class-methods-use-this: "off" */
import { GridMouseHandler, GridUtils, isEditableGridModel } from '@deephaven/grid';
import { assertNotNull } from '@deephaven/utils';

/**
 * Handles sending data selected via double click
 */

class PendingMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super();
    this.irisGrid = irisGrid;
  }
  onWheel(gridPoint, grid, wheelEvent) {
    var irisGrid = this.irisGrid;
    var model = irisGrid.props.model;
    var _irisGrid$state = irisGrid.state,
      metrics = _irisGrid$state.metrics,
      pendingRowCount = _irisGrid$state.pendingRowCount;
    assertNotNull(metrics);
    var bottom = metrics.bottom,
      rowCount = metrics.rowCount,
      rowHeight = metrics.rowHeight;
    var _GridUtils$getScrollD = GridUtils.getScrollDelta(wheelEvent),
      deltaY = _GridUtils$getScrollD.deltaY;
    if (isEditableGridModel(model) && model.isEditable && bottom >= rowCount - 1 && deltaY > 0) {
      // We add new rows onto the bottom, but we don't consume the event
      irisGrid.setState({
        pendingRowCount: pendingRowCount + Math.ceil(deltaY / rowHeight)
      });
    }
    return false;
  }
}
export default PendingMouseHandler;
//# sourceMappingURL=PendingMouseHandler.js.map